export default {"src":"/_next/static/media/redirect.c6ed9a10.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};